module.exports = __webpack_public_path__ + "static/media/kapitalbank.1aee9aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/kapitalbank.png
// module id = 673
// module chunks = 0